// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__h051m","row":"ProcedureTreatmentSummary_row__3sA_p"};